"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInvoiceBadgeValues = exports.InvoiceBadge = void 0;
var tslib_1 = require("tslib");
var core_money_1 = require("@newfront-insurance/core-money");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var badge_1 = require("../badge");
function InvoiceBadge(_a) {
    var totalCost = _a.totalCost, testId = _a.testId;
    var _b = getInvoiceBadgeValues(totalCost), type = _b.type, value = _b.value;
    return (react_1.default.createElement(badge_1.Badge, { type: type, testId: testId }, value));
}
exports.InvoiceBadge = InvoiceBadge;
function getInvoiceBadgeValues(totalCost) {
    var costAsMoney = (0, core_money_1.isMoney)(totalCost) ? totalCost : (0, core_money_1.toMoney)(totalCost);
    var costAsNumber = (0, core_money_1.isMoney)(totalCost) ? (0, core_money_1.numberFromMoney)(totalCost) : totalCost;
    return {
        type: costAsNumber >= 0 ? 'success' : 'danger',
        value: (0, core_money_1.moneyToString)(costAsMoney, { fractionDigits: 2 }),
    };
}
exports.getInvoiceBadgeValues = getInvoiceBadgeValues;
//# sourceMappingURL=index.js.map